var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisplaySidebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.7 60.5",
    style: {
      enableBackground: "new 0 0 86.7 60.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#252425;}\n\t.st1{fill:#E35955;}\n\t.st2{fill:#FEFEFE;}\n\t.st3{fill:#202021;}\n\t.st4{fill:#050505;}\n\t.st5{fill:#D9292A;}\n\t.st6{fill:#DA3E33;}\n\t.st7{fill:#6A6A6A;}\n\t.st8{fill:#686868;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M43.3,11.6c-13.1,0-26.2,0-39.3,0c-1.8,0-2.7-0.4-2.4-2.3c0.3-2.3-1-5.4,0.6-6.7c1.3-1.1,4.3-0.4,6.6-0.4 c24.5,0,49,0,73.6-0.1c2.2,0,3.1,0.4,2.8,2.7C84.8,7,86,9.8,84.6,11.2c-1.4,1.4-4.1,0.4-6.3,0.4C66.7,11.6,55,11.6,43.3,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.3,34.8c-13.1,0-26.2,0-39.3,0c-1.9,0-2.6-0.5-2.4-2.4c0.3-2.3-1-5.4,0.5-6.8c1.3-1.1,4.3-0.4,6.6-0.4 c24.6,0,49.2,0,73.8-0.1c2.1,0,2.9,0.5,2.6,2.6c-0.2,1.5-0.2,3,0,4.5c0.3,2.1-0.7,2.5-2.6,2.5C69.4,34.8,56.3,34.8,43.3,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M64.1,48.5c6.3,0,12.6,0,18.9,0c1.6,0,2.3,0.3,2.1,2.1c-0.2,2.3,0.7,5.3-0.4,6.8c-1.3,1.6-4.4,0.5-6.7,0.5 c-10.8,0.1-21.6,0-32.5,0.1c-1.7,0-2.4-0.5-2.2-2.2c0.1-1.7,0.1-3.5,0-5.3c-0.1-1.6,0.4-2,2-2C51.5,48.5,57.8,48.5,64.1,48.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplaySidebar);
export default __webpack_public_path__ + "static/media/display-sidebar.faf50937.svg";
export { ForwardRef as ReactComponent };